<template>
  <div>
    <!-- <el-button type="primary" icon="el-icon-plus"  circle @click="addGoods" v-if="!readonly" style="float:right;margin:10px 15px 10px 0;"></el-button> -->
    <el-table ref="list" border :data="tableData" style="width: 100%" @row-click="rowClick">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <!-- <el-table-column prop="GoodsName" label="商品名称" /> -->
      <el-table-column label="单位" min-width="100px" prop="UnitId">
        <template slot-scope="{ row ,$index }">
          <!-- <unit-select v-if="!readonly" v-model="row.UnitId" @change="getUnit(row)"></unit-select> -->
          <el-autocomplete v-if="!readonly"
                id="autocomplete"
                ref="autocomplete"
                v-model="row.UnitName"
                value-key="UnitName"
                :fetch-suggestions="querySearchAsync"
                placeholder="请选择单位"
                @select="handleSelect"
                style="flex: 1; margin-right: 5px"
                @change="getUnit(row,$index)"
              ></el-autocomplete>
          <span v-else>{{row.UnitName}}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否主单位" align="center" width="100px" fixed="right">
        <template slot-scope="{row}">
          <el-switch size="mini" @change="onChange(row)" v-model="row.IsMain"></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="Rate" label="换算率">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.Rate"
            type="number"
            @blur="onBlur(row,'Rate')"
            @focus="onFocus(row,'Rate')"
            @input="rateChange(row)"
            :disabled="row.IsMain"
            v-if="!readonly"
          ></el-input>
          <span v-else>{{$commonJs.toThousands(row.Rate)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="130px" v-if="!readonly">
        <template slot-scope="{ row,$index }">
          <el-link icon="el-icon-delete" @click.stop="del(row,$index)" :underline="false">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-divider></el-divider>
  </div>
</template>
<script>
import accountSelect from "@/components/sales/business/select";
import unitSelect from "@/components/basicinfo/goods/unit/select";
export default {
  props: {
    info: {},
    readonly: {
      type: Boolean,
      default: false,
    },
    showTax: {
      type: Number,
      default: 0,
    },
  },
  components: {
    accountSelect,
    unitSelect,
  },
  data() {
    return {
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      tableData: [
        {
          T: 0,
          GoodsUnitId: 0,
          GoodsId: 0,
          UnitId: 0,
          IsMain: false,
          Rate: 0,
          Sort: 0,
        },
      ],
      current: null,
      tableDel: [],
      sApi: require("@/api/goods/goods").default,
      api: require("@/api/sale/stInDoc").default,
      saleApi: require("@/api/sale/sales").default,
      account_api: require("@/api/goods/goods").default,
      unit_api: require("@/api/ba/unit").default,
      PriAdjustGoodsList: [],
      DAccount: [],
      initDAccount: [],
      initTotal: 0,
      UnitList:[],
      tIndex:0
    };
  },
  mounted() {
    this.account_api
      .list({ Status: 1, pageIndex: 1, pageSize: 7 })
      .then((res) => {
        if (res.Code == 0)
          (this.DAccount = res.Data),
            (this.initDAccount = res.Data),
            (this.initTotal = res.Count);
      }); 
      this.getDataFunc();     
  },
  methods: {
    getDataFunc() {
        this.unit_api.list({ Status: 1 }).then((res) => {
          this.UnitList = res.Data;        
      });
    },
     querySearchAsync(queryString, cb) {
      var multiUnits = this.UnitList;
      var results = queryString ? multiUnits.filter(this.createFilter(queryString)) : multiUnits;
      // 调用 callback 返回建议列表的数据
      console.log(results); 
      cb(results);

    },
    createFilter(queryString) {
        return (multiUnits) => {
        return (multiUnits.UnitName.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
    },

    handleSelect(item) {
      this.tableData[this.tIndex].T = this.tableData[this.tIndex].T == 0 ? 0 : 1;
      this.tableData[this.tIndex].UnitId=item.UnitId;
      this.tableData[this.tIndex].UnitName=item.UnitName;
    },
    getUnit(row,index) {
      if (row.T != 0) {
        row.T = 1;
      }
      this.tIndex=index;
      //
      // var index = this.tableData.MultiUnitIds.findIndex(
      //   (x) => x == this.tableData.MainUnitId
      // );
      // if (index != -1) this.tableData.MultiUnitIds.splice(index, 1);
      // this.unit_api.list({ NoId: this.tableData.MainUnitId }).then((res) => {
      //   this.MultiUnits = res.Data;
      // });
    },
    onChange(row) {
      this.tableData.forEach((x) => {
        x.T = x.T == 0 ? 0 : 1;
        x.IsMain = false;
      });
      row.IsMain = true;
      row.Rate = 1;
    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage(val) {
      this.pageParams.pageIndex = val;
      this.account_api
        .list({ Status: 1, pageIndex: val, pageSize: 7 })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;

            this.listTotal = res.Count;
          }
        });
    },
    inputText(text) {
      this.account_api
        .list({ Status: 1, pageIndex: 1, pageSize: 7, GoodsName: text })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;

            this.listTotal = res.Count;
          }
        });
    },
    validateCounts(row, index, e, name) {
      e.target.blur(); // 或者this.$refs[row.id].blur()
      this.$refs[Object.keys(this.$refs)[index + 1] + name].focus();
    },
    rowClick(row) {
      if (!this.readonly) {
        var index = this.$refs.list.data.indexOf(row);
        if (index + 1 == this.$refs.list.data.length) {
          //
          this.addGoods();
        }
      }
    },
    getData() {
      // this.tableData = [];
      this.tableData = this.info.MultiUnits;
      console.log(this.info);
      if (this.info.MultiUnits.length == 0) {
        this.tableData = [
          {
            T: 0,
            GoodsUnitId: 0,
            GoodsId: this.info.GoodsId,
            UnitId: 0,
            IsMain: false,
            Rate: 0,
            Sort: 0,
          },
        ];
      }

      // this.saleApi.getGoodsList(this.info.OrderId).then((res) => {
      //   this.tableData = res.Data;
      // });
    },
    del(row, index) {
      this.$confirm("确认删除该行数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (row.T !== 0) {
          row.T = 2;
          this.tableDel.push(row);
        }
        if (this.tableData.length == 1) {
          this.tableData.splice(index, 1);
          this.addGoods();
        } else {
          this.tableData.splice(index, 1);
        }
        this.subTable();
      });
    },
    addGoods() {
      // let ids = this.PriAdjustGoodsList.map((x) => x.GoodsId);
      // this.$refs.goodsDialog.open().then((that) => {
      //   that.getData({ Status: 1, NotIds: ids });
      // });
      let goods = {
        T: 0,
        GoodsUnitId: 0,
        GoodsId: this.info.GoodsId || 0,
        UnitId: 0,
        IsMain: false,
        Rate: 0,
        Sort: 0,
      };
      this.tableData.push(goods);
    },
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0;
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null;
    },
    changeNum(row) {
      // row.Quantity = Math.floor(row.Quantity)
      this.count(row);
    },
    rateChange(row) {
      this.count(row);
    },
    disChange(row) {
      this.count(row);
    },
    count(row) {
      if (row.T !== 0) row.T = 1;
      this.subTable();
    },
    subTable() {
      this.$emit("getList", this.tableData.concat(this.tableDel));
    },
    clear() {
      this.tableData = [
        {
          T: 0,
          GoodsUnitId: 0,
          GoodsId: 0,
          UnitId: 0,
          IsMain: false,
          Rate: 0,
          Sort: 0,
        },
      ];
      this.tableDel = [];
    },
  },
};
</script>

<style>
.el-link {
  font-size: 14px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>